// Lib
import { createSelector } from 'reselect';

// Utils
import { asObject } from '../../../common/utils/immutableHelper';

export const getCanvasSize = (state) => state.getIn(['app', 'canvas', 'size']);

export const getCanvasSizePojo = createSelector(getCanvasSize, asObject);
